// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"868be756","722":"c1f0bc19","885":"1d941bd3"}[chunkId] + ".chunk.js";
};